/* global window, document, URL, Blob */
import angular from 'angular';
import * as R from 'ramda';
import constants from 'app/constants';
import { alerts } from 'app/components/global';
import IComplianceAppDataService from './IComplianceApp.data.service';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

let _upload;

const library = require('@safe-systems/ss-ui-components');

const { copy } = library;

let _alerts;

class amDataService extends IComplianceAppDataService {
  constructor(
    $http,
    Upload,
    alerts, // eslint-disable-line no-shadow
    utilityService, // eslint-disable-line no-shadow
  ) {
    super($http, utilityService, 'am', { settings: 'settings' });
    _upload = Upload;
    _alerts = alerts;
    console.log('app.services.amDataService created');
  }

  // ///////////// Audit Trail ///////////////////
  initAuditTrail() {
    return this.$http({
      url: `${this.apiRootUrl}/am/auditTrail/initAuditTrail`,
      method: 'GET',
      params: {},
    });
  }

  // ///////////// Audit ///////////////////
  getAudits() {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit`,
      method: 'GET',
      params: {},
    });
  }

  getAudit(auditId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/${auditId}`,
      method: 'GET',
      params: {},
    });
  }

  getBaseAudit(auditId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/${auditId}/base/`,
      method: 'GET',
      params: {},
    });
  }

  getAuditDetail(auditId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/${auditId}/detail/`,
      method: 'GET',
      params: {},
    });
  }

  allowNewAudit() {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/`,
      method: 'GET',
      params: {
        action: 'allowNewAudit',
      },
    });
  }

  checkAuditExists(name, auditId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/checkExists/`,
      method: 'GET',
      params: {
        id: auditId,
        name,
      },
    });
  }

  saveAudit(audit) {
    const auditFields = [];

    // Process Preparation Item Audit Fields
    if (audit.preparationItemFields) {
      audit.preparationItemFields.forEach(entry => {
        const auditField = {
          auditFieldId: entry.auditFieldId,
          auditFieldName: entry.auditFieldName,
          dataTypeId: entry.dataTypeId,
          enabled: entry.enabled,
        };

        auditFields.push(auditField);
      });
    }

    // Process Finding Audit Fields
    if (audit.findingFields) {
      audit.findingFields.forEach(entry => {
        const auditField = {
          auditFieldId: entry.auditFieldId,
          auditFieldName: entry.auditFieldName,
          dataTypeId: entry.dataTypeId,
          enabled: entry.enabled,
        };

        auditFields.push(auditField);
      });
    }

    // Process Finding Audit Fields
    if (audit.recommendationFields) {
      audit.recommendationFields.forEach(entry => {
        const auditField = {
          auditFieldId: entry.auditFieldId,
          auditFieldName: entry.auditFieldName,
          dataTypeId: entry.dataTypeId,
          enabled: entry.enabled,
        };

        auditFields.push(auditField);
      });
    }

    const a = {
      auditId: audit.auditId,
      customerId: audit.customerId,
      agencyId: audit.agencyId,
      agencyIsThirdParty: audit.agencyIsThirdParty,
      coordinatorUserId: audit.coordinatorUserId,
      auditTypeId: audit.auditTypeId,
      name: audit.name,
      leadExaminerName: audit.leadExaminerName,
      leadExaminerPhone: audit.leadExaminerPhone,
      leadExaminerEmail: audit.leadExaminerEmail,
      isActive: audit.isActive,
      startDate: audit.startDate,
      preparationItemsDefaultDueDate: audit.preparationItemsDefaultDueDate,
      findingsDefaultDueDate: audit.findingsDefaultDueDate,
      recommendationsDefaultDueDate: audit.recommendationsDefaultDueDate,
      onsiteDate: audit.onsiteDate,
      findingRemediationStartDate: audit.findingRemediationStartDate,
      notes: audit.notes,
      auditFields,
    };

    if (!R.isNil(audit.agencyId)) {
      a.agencyId = audit.agencyId;
    }

    if (a.auditId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/am/audit/${a.auditId}`,
        method: 'PUT',
        data: JSON.stringify(a),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/Json' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/am/audit`,
      method: 'POST',
      data: JSON.stringify(a),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  completeAudit(auditId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/${auditId}/complete`,
      method: 'PUT',
      data: {},
      responseType: 'json',
      params: {
        echo: true,
      },
    });
  }

  reopenAudit(auditId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/${auditId}/reopen`,
      method: 'PUT',
      data: {},
      responseType: 'json',
      params: {
        echo: true,
      },
    });
  }

  deleteAudit(auditId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/${auditId}`,
      method: 'DELETE',
      params: {},
    });
  }

  hasIncompleteAudit(customerId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit`,
      method: 'GET',
      params: {
        action: 'hasIncompleteAudit',
        customerId,
      },
    });
  }

  // ///////////// Audit Fields ///////////////////
  getAuditFields(auditId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/${auditId}/auditField`,
      method: 'GET',
      params: {},
    });
  }

  getAssignableAuditFields(auditId, entityTypeId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/${auditId}/assignableField/${entityTypeId}`,
      method: 'GET',
      params: {},
    });
  }

  getCustomerAuditFields() {
    return this.$http({
      url: `${this.apiRootUrl}/am/auditField`,
      method: 'GET',
      params: {},
    });
  }

  // ///////////// Preparation Item Categories ////////////////////
  getPreparationItemCategoriesByAudit(auditId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/${auditId}/preparationItemCategory`,
      method: 'GET',
      params: {},
    });
  }

  getPreparationItemCategory(preparationItemCategoryId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemCategory/${preparationItemCategoryId}`,
      method: 'GET',
      params: {},
    });
  }

  savePreparationItemCategory(preparationItemCategory) {
    if (preparationItemCategory.preparationItemCategoryId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/am/preparationItemCategory/${preparationItemCategory.preparationItemCategoryId}`,
        method: 'PUT',
        data: this.serializeData(preparationItemCategory),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemCategory`,
      method: 'POST',
      data: this.serializeData(preparationItemCategory),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deletePreparationItemCategory(preparationItemCategoryId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemCategory/${preparationItemCategoryId}`,
      method: 'DELETE',
      params: {},
    });
  }

  checkPreparationItemCategoryExists(auditId, preparationItemCategoryId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemCategory/checkExists`,
      method: 'GET',
      params: {
        name,
        auditId,
        id: preparationItemCategoryId,
      },
    });
  }

  // ///////////// Preparation Items ////////////////////
  getDefaultPreparationItem(preparationItemCategoryId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemCategory/${preparationItemCategoryId}/preparationItem/default`,
      method: 'GET',
      params: {},
    });
  }

  getPreparationItemsByPreparationItemCategory(preparationItemCategoryId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemCategory/${preparationItemCategoryId}/preparationItem`,
      method: 'GET',
      params: {},
    });
  }

  getPreparationItemsByAuditAndStatuses(auditId, statuses) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/${auditId}/preparationItem`,
      method: 'GET',
      params: {
        statuses,
      },
    });
  }

  getPreparationItem(preparationItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItem/${preparationItemId}`,
      method: 'GET',
      params: {},
    });
  }

  addPreparationItem(preparationItem) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItem`,
      method: 'POST',
      data: this.serializeData(preparationItem),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  updatePreparationItem(preparationItem) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItem/${preparationItem.preparationItemId}`,
      method: 'PUT',
      data: this.serializeData(preparationItem),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deletePreparationItem(preparationItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItem/${preparationItemId}`,
      method: 'DELETE',
      params: {},
    });
  }

  setPreparationItemStatus(preparationItemId, preparationItemStatusId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemStatus`,
      method: 'POST',
      data: null,
      params: {
        echo: true,
        preparationItemId,
        preparationItemStatusId,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  checkPreparationItemExists(preparationItemCategoryId, preparationItemId, description) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItem/checkDescriptionExists`,
      method: 'GET',
      params: {
        description,
        preparationItemCategoryId,
        preparationItemId,
      },
    });
  }

  checkPreparationItemReferenceNumberExists(auditId, preparationItemId, referenceNumber) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItem/checkReferenceNumberExists`,
      method: 'GET',
      params: {
        referenceNumber,
        auditId,
        preparationItemId,
      },
    });
  }

  // ///////////// Preparation Item Folders ////////////////////
  getPreparationItemFolder(preparationItemFolderId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemFolder/${preparationItemFolderId}`,
      method: 'GET',
      params: {},
    });
  }

  getPreparationItemFoldersByFolder(folderId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemFolder/byFolder`,
      method: 'GET',
      params: {
        folderId,
      },
    });
  }

  getPreparationItemFoldersByPreparationItem(preparationItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItem/${preparationItemId}/preparationItemFolder`,
      method: 'GET',
      params: {},
    });
  }

  attachPreparationItemFolder(preparationItemId, folderId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemFolder`,
      method: 'POST',
      data: this.serializeData({
        preparationItemId,
        folderId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachPreparationItemFolder(preparationItemFolderId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemFolder/${preparationItemFolderId}`,
      method: 'DELETE',
      params: {},
    });
  }

  // ///////////// Preparation Item Documents ////////////////////
  getPreparationItemDocument(preparationItemDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemDocument/${preparationItemDocumentId}`,
      method: 'GET',
      params: {},
    });
  }

  getPreparationItemDocumentsByFolder(folderId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemFolder/${folderId}/preparationItemDocument`,
      method: 'GET',
      params: {},
    });
  }

  getPreparationItemDocumentsByPreparationItem(preparationItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItem/${preparationItemId}/preparationItemDocument`,
      method: 'GET',
      params: {},
    });
  }

  attachPreparationItemDocument(preparationItemId, documentId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemDocument`,
      method: 'POST',
      data: this.serializeData({
        preparationItemId,
        documentId,
        name
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachPreparationItemDocument(preparationItemDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemDocument/${preparationItemDocumentId}`,
      method: 'DELETE',
      params: {},
    });
  }

  // ///////////// Preparation Item Reports ////////////////////
  getPreparationItemReport(preparationItemReportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemReport/${preparationItemReportInstanceId}`,
      method: 'GET',
      params: {},
    });
  }

  getPreparationItemReportsByPreparationItem(preparationItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItem/${preparationItemId}/preparationItemReport`,
      method: 'GET',
      params: {},
    });
  }

  attachPreparationItemReport(preparationItemId, reportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemReport`,
      method: 'POST',
      data: this.serializeData({
        preparationItemId,
        reportInstanceId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachPreparationItemReport(preparationItemReportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemReport/${preparationItemReportInstanceId}`,
      method: 'DELETE',
      params: {},
    });
  }

  // ///////////// Preparation Item Comments ////////////////////
  getPreparationItemCommentsByPreparationItem(preparationItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItem/${preparationItemId}/preparationItemComment`,
      method: 'GET',
      params: {},
    });
  }

  getPreparationItemComment(preparationItemCommentId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemComment/${preparationItemCommentId}`,
      method: 'GET',
      params: {},
    });
  }

  savePreparationItemComment(preparationItemId, preparationItemCommentId, preparationItemCommentText) {
    if (preparationItemCommentId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/am/preparationItemComment/${preparationItemCommentId}`,
        method: 'PUT',
        data: this.serializeData({
          preparationItemId,
          text: preparationItemCommentText,
        }),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemComment`,
      method: 'POST',
      data: this.serializeData({
        preparationItemId,
        preparationItemCommentId,
        text: preparationItemCommentText,
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deletePreparationItemComment(preparationItemCommentId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemComment/${preparationItemCommentId}`,
      method: 'DELETE',
      params: {},
    });
  }

  // ///////////// Preparation Item Package ///////////////////

  generatePreparationItemPackageFileList(auditId) {
    return this.$http.post(
      `${this.apiRootUrl}/am/auditPackage`,
      {},
      {
        params: {
          action: 'generatePreparationItemPackageList',
          auditId,
        },
      },
    );
  }

  createPreparationItemPackageFileGenerationRequest(auditId) {
    return this.$http.post(`${this.apiRootUrl}/am/audit/${auditId}/generatePreparationItemPackage`, {}, {});
  }

  

  // ///////////// Recommendation Categories ////////////////////
  getRecommendationCategoriesByAudit(auditId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/${auditId}/recommendationCategory`,
      method: 'GET',
      params: {},
    });
  }

  getRecommendationCategory(recommendationCategoryId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationCategory/${recommendationCategoryId}`,
      method: 'GET',
      params: {},
    });
  }

  saveRecommendationCategory(recommendationCategory) {
    if (recommendationCategory.recommendationCategoryId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/am/recommendationCategory/${recommendationCategory.recommendationCategoryId}`,
        method: 'PUT',
        data: this.serializeData(recommendationCategory),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationCategory`,
      method: 'POST',
      data: this.serializeData(recommendationCategory),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteRecommendationCategory(recommendationCategoryId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationCategory/${recommendationCategoryId}`,
      method: 'DELETE',
      params: {},
    });
  }

  checkRecommendationCategoryExists(auditId, recommendationCategoryId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationCategory/checkExists`,
      method: 'GET',
      params: {
        name,
        auditId,
        id: recommendationCategoryId,
      },
    });
  }

  // ///////////// Recommendations ////////////////////
  getDefaultRecommendation(recommendationCategoryId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationCategory/${recommendationCategoryId}/recommendation/default`,
      method: 'GET',
      params: {},
    });
  }

  getRecommendationsByRecommendationCategory(recommendationCategoryId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationCategory/${recommendationCategoryId}/recommendation`,
      method: 'GET',
      params: {},
    });
  }

  getRecommendationsByAuditAndStatuses(auditId, statuses) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendation/byAuditAndStatuses`,
      method: 'GET',
      params: {
        auditId,
        statuses,
      },
    });
  }

  getRecommendation(recommendationId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendation/${recommendationId}`,
      method: 'GET',
      params: {},
    });
  }

  addRecommendation(recommendation) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendation`,
      method: 'POST',
      data: this.serializeData(recommendation),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  updateRecommendation(recommendation) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendation/${recommendation.recommendationId}`,
      method: 'PUT',
      data: this.serializeData(recommendation),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteRecommendation(recommendationId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendation/${recommendationId}`,
      method: 'DELETE',
      params: {},
    });
  }

  setRecommendationStatus(recommendationId, recommendationStatusId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationStatus`,
      method: 'POST',
      data: null,
      params: {
        echo: true,
        recommendationId,
        recommendationStatusId,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  checkRecommendationExists(recommendationCategoryId, recommendationId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendation/checkNameExists`,
      method: 'GET',
      params: {
        name,
        recommendationCategoryId,
        recommendationId,
      },
    });
  }

  checkRecommendationReferenceNumberExists(auditId, recommendationId, referenceNumber) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendation/checkReferenceNumberExists`,
      method: 'GET',
      params: {
        referenceNumber,
        auditId,
        recommendationId,
      },
    });
  }

  validateRecommendationDueDateHasAssignedUser(recommendationId, referenceNumber) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendation`,
      method: 'GET',
      params: {
        action: 'checkReferenceNumber',
        recommendationId,
        referenceNumber,
      },
    });
  }

  validateRecommendationAssignedUserHasDueDate(recommendationId, referenceNumber) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendation`,
      method: 'GET',
      params: {
        action: 'checkReferenceNumber',
        recommendationId,
        referenceNumber,
      },
    });
  }

  // ///////////// Recommendation Folders ////////////////////
  getRecommendationFolder(recommendationFolderId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationFolder/${recommendationFolderId}`,
      method: 'GET',
      params: {},
    });
  }

  getRecommendationFoldersByFolder(folderId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationFolder/byFolder`,
      method: 'GET',
      params: {
        folderId,
      },
    });
  }

  getRecommendationFoldersByRecommendation(recommendationId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendation/${recommendationId}/recommendationFolder`,
      method: 'GET',
      params: {},
    });
  }

  attachRecommendationFolder(recommendationId, folderId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationFolder`,
      method: 'POST',
      data: this.serializeData({
        recommendationId,
        folderId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachRecommendationFolder(recommendationFolderId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationFolder/${recommendationFolderId}`,
      method: 'DELETE',
      params: {},
    });
  }

  // ///////////// Recommendation Documents ////////////////////
  getRecommendationDocument(recommendationDocumentId) {
    console.log('getRecommendationDocument');
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationDocument/${recommendationDocumentId}`,
      method: 'GET',
      params: {},
    });
  }

  getRecommendationDocumentsByFolder(folderId) {
    console.log('getRecommendationDocumentsByFolder');
    return this.$http({
      url: `${this.apiRootUrl}/am/folder/${folderId}/recommendationDocument`,
      method: 'GET',
      params: {},
    });
  }

  getRecommendationDocumentsByRecommendation(recommendationId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendation/${recommendationId}/recommendationDocument`,
      method: 'GET',
      params: {},
    });
  }

  attachRecommendationDocument(recommendationId, documentId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationDocument`,
      method: 'POST',
      data: this.serializeData({
        recommendationId,
        documentId,
        name
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachRecommendationDocument(recommendationDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationDocument/${recommendationDocumentId}`,
      method: 'DELETE',
      params: {},
    });
  }

  updateRecommendationDocument(recommendationDocument) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationDocument/${recommendationDocument.recommendationDocumentId}`,
      method: 'PUT',
      data: JSON.stringify(recommendationDocument),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  uploadRecommendationDocument(recommendationId, recommendationDocument) {
    return _upload.upload({
      url: `${this.apiRootUrl}/am/recommendationDocument/${recommendationId}/document/upload`,
      data: {
        recommendationId,
        assessmentDocumentId: recommendationDocument.assessmentDocumentId,
        assessmentDocumentTypeId: recommendationDocument.assessmentDocumentTypeId,
        completedDate: recommendationDocument.completedDate,
        displayValue: recommendationDocument.name,
        isDeletable: recommendationDocument.deletable,
        file: recommendationDocument.file,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  checkRecommendationDocumentDisplayNameExists(recommendationId, recommendationIdDocumentId, displayName) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationDocument/checkDisplayNameExists/`,
      method: 'GET',
      params: {
        recommendationId,
        recommendationIdDocumentId,
        displayName,
      },
    });
  }

  checkRecommendationDocumentFileNameExists(recommendationId, recommendationIdDocumentId, fileName) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationDocument/checkFileNameExists/`,
      method: 'GET',
      params: {
        recommendationId,
        recommendationIdDocumentId,
        fileName,
      },
    });
  }

  // ///////////// Recommendation Reports ////////////////////
  getRecommendationReport(recommendationReportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationReport/${recommendationReportInstanceId}`,
      method: 'GET',
      params: {},
    });
  }

  getRecommendationReportsByRecommendation(recommendationId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendation/${recommendationId}/recommendationReport`,
      method: 'GET',
      params: {},
    });
  }

  attachRecommendationReport(recommendationId, reportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationReport`,
      method: 'POST',
      data: this.serializeData({
        recommendationId,
        reportInstanceId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachRecommendationReport(recommendationReportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationReport/${recommendationReportInstanceId}`,
      method: 'DELETE',
      params: {},
    });
  }

  // ///////////// Recommendation Comments ////////////////////
  getRecommendationCommentsByRecommendation(recommendationId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendation/${recommendationId}/recommendationComment`,
      method: 'GET',
      params: {},
    });
  }

  getRecommendationComment(recommendationCommentId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationComment/${recommendationCommentId}`,
      method: 'GET',
      params: {},
    });
  }

  saveRecommendationComment(recommendationId, recommendationCommentId, recommendationCommentText) {
    if (recommendationCommentId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/am/recommendationComment/${recommendationCommentId}`,
        method: 'PUT',
        data: this.serializeData({
          recommendationId,
          text: recommendationCommentText,
        }),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationComment`,
      method: 'POST',
      data: this.serializeData({
        recommendationId,
        recommendationCommentId,
        text: recommendationCommentText,
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteRecommendationComment(recommendationCommentId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendationComment/${recommendationCommentId}`,
      method: 'DELETE',
      params: {},
    });
  }

  // ///////////// Recommendation Package ///////////////////

  generateRecommendationPackageFileList(auditId) {
    return this.$http.post(
      `${this.apiRootUrl}/am/auditPackage`,
      {},
      {
        params: {
          action: 'generateRecommendationPackageList',
          auditId,
        },
      },
    );
  }

  createRecommendationPackageFileGenerationRequest(auditId) {
    return this.$http.post(`${this.apiRootUrl}/am/audit/${auditId}/generateRecommendationPackage`, {}, {});
  }

  // ///////////// Finding Categories ////////////////////
  getFindingCategoriesByAudit(auditId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/audit/${auditId}/findingCategory`,
      method: 'GET',
      params: {},
    });
  }

  getFindingCategory(findingCategoryId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingCategory/${findingCategoryId}`,
      method: 'GET',
      params: {},
    });
  }

  saveFindingCategory(findingCategory) {
    if (findingCategory.findingCategoryId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/am/findingCategory/${findingCategory.findingCategoryId}`,
        method: 'PUT',
        data: this.serializeData(findingCategory),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/am/findingCategory`,
      method: 'POST',
      data: this.serializeData(findingCategory),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteFindingCategory(findingCategoryId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingCategory/${findingCategoryId}`,
      method: 'DELETE',
      params: {},
    });
  }

  checkFindingCategoryExists(auditId, findingCategoryId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingCategory/checkExists`,
      method: 'GET',
      params: {
        name,
        auditId,
        id: findingCategoryId,
      },
    });
  }

  // ///////////// Findings ////////////////////
  getDefaultFinding(findingCategoryId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingCategory/${findingCategoryId}/finding/default`,
      method: 'GET',
      params: {},
    });
  }

  getFindingsByFindingCategory(findingCategoryId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingCategory/${findingCategoryId}/finding`,
      method: 'GET',
      params: {},
    });
  }

  getFindingsByAuditAndStatuses(auditId, statuses) {
    return this.$http({
      url: `${this.apiRootUrl}/am/finding/byAuditAndStatuses`,
      method: 'GET',
      params: {
        auditId,
        statuses,
      },
    });
  }

  getFinding(findingId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/finding/${findingId}`,
      method: 'GET',
      params: {},
    });
  }

  addFinding(finding) {
    return this.$http({
      url: `${this.apiRootUrl}/am/finding`,
      method: 'POST',
      data: this.serializeData(finding),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  updateFinding(finding) {
    return this.$http({
      url: `${this.apiRootUrl}/am/finding/${finding.findingId}`,
      method: 'PUT',
      data: this.serializeData(finding),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteFinding(findingId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/finding/${findingId}`,
      method: 'DELETE',
      params: {},
    });
  }

  setFindingStatus(findingId, findingStatusId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingStatus`,
      method: 'POST',
      data: null,
      params: {
        echo: true,
        findingId,
        findingStatusId,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  checkFindingExists(findingCategoryId, findingId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/am/finding/checkNameExists`,
      method: 'GET',
      params: {
        name,
        findingCategoryId,
        findingId,
      },
    });
  }

  checkFindingReferenceNumberExists(auditId, findingId, referenceNumber) {
    return this.$http({
      url: `${this.apiRootUrl}/am/finding/checkReferenceNumberExists`,
      method: 'GET',
      params: {
        referenceNumber,
        auditId,
        findingId,
      },
    });
  }

  validateFindingDueDateHasAssignedUser(findingId, referenceNumber) {
    return this.$http({
      url: `${this.apiRootUrl}/am/finding`,
      method: 'GET',
      params: {
        action: 'checkReferenceNumber',
        findingId,
        referenceNumber,
      },
    });
  }

  validateFindingAssignedUserHasDueDate(findingId, referenceNumber) {
    return this.$http({
      url: `${this.apiRootUrl}/am/finding`,
      method: 'GET',
      params: {
        action: 'checkReferenceNumber',
        findingId,
        referenceNumber,
      },
    });
  }

  // ///////////// Finding Folders ////////////////////
  getFindingFolder(findingFolderId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingFolder/${findingFolderId}`,
      method: 'GET',
      params: {},
    });
  }

  getFindingFoldersByFolder(folderId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingFolder/byFolder`,
      method: 'GET',
      params: {
        folderId,
      },
    });
  }

  getFindingFoldersByFinding(findingId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/finding/${findingId}/findingFolder`,
      method: 'GET',
      params: {},
    });
  }

  attachFindingFolder(findingId, folderId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingFolder`,
      method: 'POST',
      data: this.serializeData({
        findingId,
        folderId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachFindingFolder(findingFolderId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingFolder/${findingFolderId}`,
      method: 'DELETE',
      params: {},
    });
  }

  // ///////////// Finding Documents ////////////////////
  getFindingDocument(findingDocumentId) {
    console.log('getFindingDocument');
    return this.$http({
      url: `${this.apiRootUrl}/am/findingDocument/${findingDocumentId}`,
      method: 'GET',
      params: {},
    });
  }

  getFindingDocumentsByFolder(folderId) {
    console.log('getFindingDocumentsByFolder');
    return this.$http({
      url: `${this.apiRootUrl}/am/folder/${folderId}/findingDocument`,
      method: 'GET',
      params: {},
    });
  }

  getFindingDocumentsByFinding(findingId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/finding/${findingId}/findingDocument`,
      method: 'GET',
      params: {},
    });
  }

  attachFindingDocument(findingId, documentId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingDocument`,
      method: 'POST',
      data: this.serializeData({
        findingId,
        documentId,
        name
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachFindingDocument(findingDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingDocument/${findingDocumentId}`,
      method: 'DELETE',
      params: {},
    });
  }

  updateFindingDocument(findingDocument) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingDocument/${findingDocument.findingDocumentId}`,
      method: 'PUT',
      data: JSON.stringify(findingDocument),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  uploadFindingDocument(findingId, findingDocument) {
    return _upload.upload({
      url: `${this.apiRootUrl}/am/findingDocument/${findingId}/document/upload`,
      data: {
        findingId,
        assessmentDocumentId: findingDocument.assessmentDocumentId,
        assessmentDocumentTypeId: findingDocument.assessmentDocumentTypeId,
        completedDate: findingDocument.completedDate,
        displayValue: findingDocument.name,
        isDeletable: findingDocument.deletable,
        file: findingDocument.file,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  checkFindingDocumentDisplayNameExists(findingId, findingIdDocumentId, displayName) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingDocument/checkDisplayNameExists/`,
      method: 'GET',
      params: {
        findingId,
        findingIdDocumentId,
        displayName,
      },
    });
  }

  checkFindingDocumentFileNameExists(findingId, findingIdDocumentId, fileName) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingDocument/checkFileNameExists/`,
      method: 'GET',
      params: {
        findingId,
        findingIdDocumentId,
        fileName,
      },
    });
  }

  // ///////////// Finding Reports ////////////////////
  getFindingReport(findingReportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingReport/${findingReportInstanceId}`,
      method: 'GET',
      params: {},
    });
  }

  getFindingReportsByFinding(findingId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/finding/${findingId}/findingReport`,
      method: 'GET',
      params: {},
    });
  }

  attachFindingReport(findingId, reportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingReport`,
      method: 'POST',
      data: this.serializeData({
        findingId,
        reportInstanceId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachFindingReport(findingReportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingReport/${findingReportInstanceId}`,
      method: 'DELETE',
      params: {},
    });
  }

  // ///////////// Finding Comments ////////////////////
  getFindingCommentsByFinding(findingId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/finding/${findingId}/findingComment`,
      method: 'GET',
      params: {},
    });
  }

  getFindingComment(findingCommentId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingComment/${findingCommentId}`,
      method: 'GET',
      params: {},
    });
  }

  saveFindingComment(findingId, findingCommentId, findingCommentText) {
    if (findingCommentId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/am/findingComment/${findingCommentId}`,
        method: 'PUT',
        data: this.serializeData({
          findingId,
          text: findingCommentText,
        }),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/am/findingComment`,
      method: 'POST',
      data: this.serializeData({
        findingId,
        findingCommentId,
        text: findingCommentText,
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteFindingComment(findingCommentId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingComment/${findingCommentId}`,
      method: 'DELETE',
      params: {},
    });
  }

  // ///////////// Finding Package ///////////////////

  generateFindingPackageFileList(auditId) {
    return this.$http.post(
      `${this.apiRootUrl}/am/auditPackage`,
      {},
      {
        params: {
          action: 'generateFindingPackageList',
          auditId,
        },
      },
    );
  }

  createFindingPackageFileGenerationRequest(auditId) {
    return this.$http.post(`${this.apiRootUrl}/am/audit/${auditId}/generateFindingPackage`, {}, {});
  }

  // ///////////// Supporting Entities ///////////////////

  getAgencies() {
    return this.$http({
      url: `${this.apiRootUrl}/am/agency/`,
      method: 'GET',
      params: {},
    });
  }

  getAgency(agencyId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/agency/${agencyId}`,
      method: 'GET',
      params: {},
    });
  }

  addAgency(agency) {
    return this.$http({
      url: `${this.apiRootUrl}/am/agency`,
      method: 'POST',
      data: this.serializeData(agency),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  updateAgency(agency) {
    return this.$http({
      url: `${this.apiRootUrl}/am/agency/${agency.agencyId}`,
      method: 'PUT',
      data: this.serializeData(agency),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteAgency(agencyId, auditId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/agency/${agencyId}`,
      method: 'DELETE',
      params: {
        auditId,
      },
    });
  }

  getAuditTypes() {
    return this.$http({
      url: `${this.apiRootUrl}/am/auditType`,
      method: 'GET',
      params: {},
    });
  }

  checkAgencyExists(name, agencyId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/agency/checkExists/`,
      method: 'GET',
      params: {
        id: agencyId,
        name,
      },
    });
  }

  getAuditType(auditTypeId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/auditType/${auditTypeId}`,
      method: 'GET',
      params: {},
    });
  }

  getDataTypes() {
    return this.$http({
      url: `${this.apiRootUrl}/am/dataType`,
      method: 'GET',
      params: {},
    });
  }

  getBusinessRisks() {
    return this.$http({
      url: `${this.apiRootUrl}/am/businessRisk`,
      method: 'GET',
      params: {},
    });
  }

  getBusinessRisk(businessRiskId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/businessRisk/${businessRiskId}`,
      method: 'GET',
      params: {},
    });
  }

  getTechnicalRisks() {
    return this.$http({
      url: `${this.apiRootUrl}/am/technicalRisk`,
      method: 'GET',
      params: {},
    });
  }

  getPriorities() {
    return this.$http({
      url: `${this.apiRootUrl}/am/priority`,
      method: 'GET',
      params: {},
    });
  }

  getFieldNameDefaults() {
    return this.$http({
      url: `${this.apiRootUrl}/am/fieldDefaults`,
      method: 'GET',
      params: {},
    });
  }

  getFindingStatuses() {
    return this.$http({
      url: `${this.apiRootUrl}/am/findingStatus`,
      method: 'GET',
      params: {},
    });
  }

  getPreparationItemStatuses() {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItemStatus`,
      method: 'GET',
      params: {},
    });
  }

  // ///////////// Reports ///////////////////

  getReports() {
    return this.$http({
      url: `${this.apiRootUrl}/am/amReport`,
      method: 'GET',
      params: {
        action: 'getList',
      },
    });
  }

  archiveReport(reportId, parameters) {
    return this.$http.post(
      `${this.apiRootUrl}/am/Reports/archiveReport`,
      {},
      {
        params: {
          reportId,
          parameters: JSON.stringify(parameters),
        },
      },
    );
  }

  getAuditTrailDetailReport() {
    return this.getReportByName('AuditExamFullDetail');
  }

  // ///// Import Preparation Items //////////
  stagePreparationItemsImportData(customerId, auditId, bankName, fileName, uploadType) {
    return this.$http.post(
      `${this.apiRootUrl}/am/preparationItems/Import/stageImportData.ashx`,
      {},
      {
        params: {
          customerId,
          auditId,
          bankName,
          fileName,
          uploadType,
        },
      },
    );
  }

  processPreparationItemsImport(preparationItemImportSetId) {
    return this.$http.post(
      `${this.apiRootUrl}/am/preparationItems/Import/processImport.ashx`,
      {},
      {
        params: {
          preparationItemImportSetId,
        },
      },
    );
  }

  getPreparationItemsImportDetails(preparationItemImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItems/Import/getImportDetails.ashx`,
      method: 'GET',
      params: {
        preparationItemImportSetId,
      },
    });
  }

  getPreparationItemsImportHeaders(preparationItemImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItems/Import/getImportHeaders.ashx`,
      method: 'GET',
      params: {
        preparationItemImportSetId,
      },
    });
  }

  getPreparationItemsImportMappings(preparationItemImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/preparationItems/Import/PreparationItemImportSetMapping`,
      method: 'GET',
      params: {
        action: 'getByPreparationItemImportSet',
        preparationItemImportSetId,
      },
    });
  }

  savePreparationItemsImportMappings(mappings) {
    return this.$http.post(
      `${this.apiRootUrl}/am/preparationItems/Import/PreparationItemImportSetMapping`,
      { mappings },
      {
        params: {
          action: 'save',
        },
      },
    );
  }

  getPreparationItemImportTemplateFile(networkPath, storeRootKey, fileType, fileName) {
    const url = `${this.apiRootUrl}/am/${networkPath}/import/handleImportFile.ashx`;
    // ?storeRootKey=' + storeRootKey + '&fileType=' + fileType + '&f=' + fileName;

    const $frmDownloadFile = angular
      .element('<form id="frmDownloadFile" method="get" target="ifrmDownloadFile"></form>')
      .appendTo(angular.element('#ifrmDownloadFile'));
    $frmDownloadFile.attr('action', url);
    $frmDownloadFile.append(angular.element('<input type="hidden" name="storeRootKey" />').val(storeRootKey));
    $frmDownloadFile.append(angular.element('<input type="hidden" name="fileType" />').val(fileType));
    $frmDownloadFile.append(angular.element('<input type="hidden" name="f" />').val(fileName));
    $frmDownloadFile.submit();
    _alerts.success(copy.amReports.alerts.downloadTemplate.text);
  }

  // ///// Import Recommendation //////////
  stageRecommendationsImportData(customerId, auditId, bankName, fileName, uploadType) {
    return this.$http.post(
      `${this.apiRootUrl}/am/recommendations/Import/stageImportData.ashx`,
      {},
      {
        params: {
          customerId,
          auditId,
          bankName,
          fileName,
          uploadType,
        },
      },
    );
  }

  processRecommendationsImport(recommendationImportSetId) {
    return this.$http.post(
      `${this.apiRootUrl}/am/recommendations/Import/processImport.ashx`,
      {},
      {
        params: {
          recommendationImportSetId,
        },
      },
    );
  }

  getRecommendationsImportDetails(recommendationImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendations/Import/getImportDetails.ashx`,
      method: 'GET',
      params: {
        recommendationImportSetId,
      },
    });
  }

  getRecommendationsImportHeaders(recommendationImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendations/Import/getImportHeaders.ashx`,
      method: 'GET',
      params: {
        recommendationImportSetId,
      },
    });
  }

  getRecommendationsImportMappings(recommendationImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/recommendations/Import/RecommendationImportSetMapping`,
      method: 'GET',
      params: {
        action: 'getByRecommendationImportSet',
        recommendationImportSetId,
      },
    });
  }

  saveRecommendationsImportMappings(mappings) {
    return this.$http.post(
      `${this.apiRootUrl}/am/recommendations/Import/RecommendationImportSetMapping`,
      { mappings },
      {
        params: {
          action: 'save',
        },
      },
    );
  }

  // ///// Import Findings //////////
  stageFindingsImportData(customerId, auditId, bankName, fileName, uploadType) {
    return this.$http.post(
      `${this.apiRootUrl}/am/findings/Import/stageImportData.ashx`,
      {},
      {
        params: {
          customerId,
          auditId,
          bankName,
          fileName,
          uploadType,
        },
      },
    );
  }

  processFindingsImport(findingImportSetId) {
    return this.$http.post(
      `${this.apiRootUrl}/am/findings/Import/processImport.ashx`,
      {},
      {
        params: {
          findingImportSetId,
        },
      },
    );
  }

  getFindingsImportDetails(findingImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findings/Import/getImportDetails.ashx`,
      method: 'GET',
      params: {
        findingImportSetId,
      },
    });
  }

  getFindingsImportHeaders(findingImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findings/Import/getImportHeaders.ashx`,
      method: 'GET',
      params: {
        findingImportSetId,
      },
    });
  }

  getFindingsImportMappings(findingImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/findings/Import/FindingImportSetMapping`,
      method: 'GET',
      params: {
        action: 'getByFindingImportSet',
        findingImportSetId,
      },
    });
  }

  saveFindingsImportMappings(mappings) {
    return this.$http.post(
      `${this.apiRootUrl}/am/findings/Import/FindingImportSetMapping`,
      { mappings },
      {
        params: {
          action: 'save',
        },
      },
    );
  }

  // ///// General Import //////////
  // getImportTemplateFile(networkPath, storeRootKey, fileType, fileName) {
  getImportTemplateFile(auditId, networkPath) {
    const url = `${this.apiRootUrl}/am/${networkPath}/Import/handleImportFile.ashx`;

    const $frmDownloadFile = angular
      .element('<form id="frmDownloadFile" method="get" target="ifrmDownloadFile"></form>')
      .appendTo(angular.element('#ifrmDownloadFile'));
    $frmDownloadFile.attr('action', url);
    $frmDownloadFile.append(angular.element('<input type="hidden" name="auditId" />').val(auditId));
    $frmDownloadFile.submit();
    _alerts.success(copy.amReports.alerts.downloadTemplate.text);
  }

  // ///// General General Download Package //////////
  downloadPackage(auditPackageId) {
    const url = `${this.apiRootUrl}/am/auditPackage/${auditPackageId}/download`;
    return this.$http({
      url,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  download(response) {
    const contentType = response.headers('Content-Type');
    const contentDisposition = response.headers('Content-Disposition');
    let fileName = '';

    if (!R.isNil(contentDisposition)) {
      // const matches = /filename="(.*?)"/g.exec(contentDisposition);
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
      fileName = matches && matches.length > 1 ? matches[1] : null;
      fileName = fileName.split('"').join('');
    }

    const blob = new Blob([response.data], { type: contentType });
    // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      anchor.setAttribute('type', 'hidden');

      anchor.href = URL.createObjectURL(blob);
      anchor.download = fileName;
      anchor.target = '_self';
      anchor.click();
    }
  }
}

amDataService.$inject = [
  '$http',
  'Upload',
  'alerts',
  'utilityService'
];

export default angular.module('app.services.amDataService', [
  ngFileUpload,
  constants,
  alerts,
])
  .service('amDataService', amDataService)
  .name;
